import React from "react";
import { Box } from "@mui/material";

const HANDLE_POSITIONS = [
  { top: "0%", left: "0%", cursor: "nwse-resize", direction: "nw" },
  { top: "0%", left: "50%", cursor: "ns-resize", direction: "n" },
  { top: "0%", left: "100%", cursor: "nesw-resize", direction: "ne" },
  { top: "100%", left: "0%", cursor: "nesw-resize", direction: "sw" },
  { top: "100%", left: "50%", cursor: "ns-resize", direction: "s" },
  { top: "100%", left: "100%", cursor: "nwse-resize", direction: "se" },
  { top: "50%", left: "0%", cursor: "ew-resize", direction: "w" },
  { top: "50%", left: "100%", cursor: "ew-resize", direction: "e" },
];

const SelectionHandles = ({ onHandleMouseDown }) => {
  return HANDLE_POSITIONS.map((pos, idx) => (
    <Box
      key={idx}
      sx={{
        position: "absolute",
        width: "8px",
        height: "8px",
        border: "1px solid blue",
        borderRadius: "2px",
        transform: "translate(-50%, -50%)",
        ...pos,
      }}
      onMouseDown={(e) => onHandleMouseDown(e, pos)}
    />
  ));
};

export default SelectionHandles;
